// extracted by mini-css-extract-plugin
export var container = "styles-module--container--Hx8sB";
export var arrow = "styles-module--arrow--2PO4d";
export var bounce = "styles-module--bounce--CHXyK";